//@ts-check
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import LoadingDelay from './LoadingDelay';
import LoadingOverlay from './LoadingOverlay';
var useStyles = makeStyles(function (theme) {
  return {
    center: {
      top: '50%',
      marginTop: -8,
      textAlign: 'center',
      position: 'absolute',
      width: 200,
      left: '50%',
      marginLeft: -100,
      backgroundColor: '#fff',
      paddingTop: 8,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'rgba(0,0,0,0.3)'
    }
  };
}, {
  name: 'ECDelayedLoading'
});
/**
 * @param {{ isLoading: boolean, delay: number, message:string }} props
 */

var DelayedLoading = function DelayedLoading(_ref) {
  var isLoading = _ref.isLoading,
      delay = _ref.delay,
      message = _ref.message;
  var classes = useStyles({});
  if (!isLoading) return null;
  return React.createElement(LoadingDelay, {
    delay: delay
  }, function () {
    return React.createElement(LoadingOverlay, null, React.createElement("span", {
      className: classes.center
    }, React.createElement(CircularProgress, {
      size: 8 * 4
    }), React.createElement(Typography, {
      color: "inherit"
    }, message)));
  });
};

DelayedLoading.defaultProps = {
  isLoading: false,
  delay: 1000,
  message: 'Please, wait...'
};
export default DelayedLoading;